import React from "react";
import CartUser from "../../../components/cart/cart";

function Cart() {
  return (
    <React.Fragment>
      <CartUser />
    </React.Fragment>
  );
}

export default Cart;
